export default __webpack_public_path__ + "static/media/identify.f89fdf48.svg";